import { render, staticRenderFns } from "./ChangeContentFrame.vue?vue&type=template&id=60b2e2b0&scoped=true"
import script from "./ChangeContentFrame.vue?vue&type=script&lang=js"
export * from "./ChangeContentFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2e2b0",
  null
  
)

export default component.exports